import * as React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';

import Fields from './Components/Fields';
import Footer from './Components/Footer';

export default class extends React.PureComponent{

  static propTypes = {
    submitting: PropTypes.bool.isRequired,
    
    componentWillMount: PropTypes.func.isRequired,
    onClickCancel: PropTypes.func.isRequired
  }

  componentWillMount = () => this.props.componentWillMount(this.props);

  render () {

    const {
      submitting,
      onClickCancel
    } = this.props;

    return (
        
      <Modal
        visible  
        title="Export Statistics"        
        onCancel={onClickCancel}
        footer={<Footer submitting={submitting} />}
      >
        
        <Fields submitting={submitting} />

      </Modal>
    )
  }
}